<template>
  <div class="sub_wrapper">
    <div class="banner_wrap zc_banner">
      <div class="b_cont">
        <h1>用户注册</h1>
        <p>送政策、送服务，助推企业发展</p>
      </div>
    </div>
    <div class="main_wrap w_1200" style="padding-bottom: 0;">
      <div class="ms_box">
        <span>注册说明：1、较多业务系统将使用填写的注册信息，请如实填写</span>
        <span>2、请牢记注册的登录账号和密码，切勿向他人泄漏</span>
      </div>
      <h1 style="text-align: center;font-size: 24px;color: #000;font-weight: 700;margin-bottom: 0;">用户注册</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "tit",
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/newStyle/css/idx.scss";

</style>
